import { render, staticRenderFns } from "./TabManager.vue?vue&type=template&id=579dd8bc&"
import script from "./TabManager.vue?vue&type=script&lang=js&"
export * from "./TabManager.vue?vue&type=script&lang=js&"
import style0 from "./TabManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports